import styled from 'styled-components';

export const Container = styled.div`
  width: ${({ theme }) => theme.spacing[112]};
  max-width: 100%;
`;
